import { defaultConfig, defineConfig, defineTokens } from '@chakra-ui/react';

import { globalCss } from './misc/global-css';
import { textStyles } from './misc/text-styles';
import { accommodationItemSlotRecipe } from './recipes/accommodation-item';
import { accordionSlotRecipe } from './recipes/accordion';
import { accordionMenuItemSlotRecipe } from './recipes/accordion-menu-item';
import { alertSlotRecipe } from './recipes/alert';
import { autocompleteSlotRecipe } from './recipes/autocomplete';
import { autocompleteItemSlotRecipe } from './recipes/autocomplete-item';
import { avatarSlotRecipe } from './recipes/avatar';
import { averageRatingSlotRecipe } from './recipes/average-rating';
import { badgeRecipe } from './recipes/badge';
import { buttonRecipe } from './recipes/button';
import { checkboxSlotRecipe } from './recipes/checkbox';
import { dialogSlotRecipe } from './recipes/dialog';
import { drawerSlotRecipe } from './recipes/drawer';
import { expandableMenuItemSlotRecipe } from './recipes/expandable-menu-item';
import { featuredCountryItemSlotRecipe } from './recipes/featured-country-item';
import { featuredImageWrapperSlotRecipe } from './recipes/featured-image-wrapper';
import { fieldSlotRecipe } from './recipes/field';
import { footerSlotRecipe } from './recipes/footer';
import { guestsPickerSlotRecipe } from './recipes/guests-picker';
import { headingRecipe } from './recipes/heading';
import { heroSlotRecipe } from './recipes/hero';
import { iconSlotRecipe } from './recipes/icon';
import { inputRecipe } from './recipes/input';
import { linkRecipe } from './recipes/link';
import { listSlotRecipe } from './recipes/list';
import { mapAdvancedMarkerSlotRecipe } from './recipes/map-advanced-marker';
import { mapPopoverSlotRecipe } from './recipes/map-popover';
import { menuSlotRecipe } from './recipes/menu';
import { mobileNumberInputSlotRecipe } from './recipes/mobile-number-input';
import { nativeSelectSlotRecipe } from './recipes/native-select';
import { navigationSlotRecipe } from './recipes/navigation';
import { newsletterSlotRecipe } from './recipes/newsletter';
import { popoverSlotRecipe } from './recipes/popover';
import { rangePickerSlotRecipe } from './recipes/range-picker';
import { rangePickerDrawerSlotRecipe } from './recipes/range-picker-drawer';
import { searchEngineDesktopSlotRecipe } from './recipes/search-engine-desktop';
import { searchEngineInstantReservationCheckboxSlotRecipe } from './recipes/search-engine-instant-reservation-checkbox';
import { searchEngineMobileSlotRecipe } from './recipes/search-engine-mobile';
import { searchEngineMobileDrawerSlotRecipe } from './recipes/search-engine-mobile-drawer';
import { searchLocationSlotRecipe } from './recipes/search-location';
import { seoLinksSlotRecipe } from './recipes/seo-links';
import { separatorRecipe } from './recipes/separator';
import { supportSlotRecipe } from './recipes/support';
import { tagSlotRecipe } from './recipes/tag';
import { toastSlotRecipe } from './recipes/toast';
import { colors as semanticColors } from './semantic-tokens/colors';
import { shadows } from './semantic-tokens/shadows';
import { colors } from './tokens/colors';
import { fontSizes } from './tokens/font-sizes';
import { fonts } from './tokens/fonts';
import { sizes } from './tokens/sizes';
import { spacing } from './tokens/spacing';
import { zIndex } from './tokens/z-index';

export const raspberryBaseTheme = defineConfig({
    globalCss,

    theme: {
        breakpoints: {
            // for some reason `base` breakpoint is not defined by default, which causes issues with breakpoint-based hooks,
            // we need to add it manually
            base: '0rem', // 0px
            ...defaultConfig?.theme?.breakpoints,
        },
        tokens: defineTokens({
            colors,
            spacing,
            sizes,
            fonts,
            fontSizes,
            zIndex,
        }),

        semanticTokens: {
            colors: semanticColors,
            shadows,
        },

        textStyles,

        // for defining component recipes
        recipes: {
            badge: badgeRecipe,
            button: buttonRecipe,
            heading: headingRecipe,
            input: inputRecipe,
            link: linkRecipe,
            separator: separatorRecipe,
        },

        // for defining component slot recipes
        slotRecipes: {
            accommodationItem: accommodationItemSlotRecipe,
            accordion: accordionSlotRecipe,
            accordionMenuItem: accordionMenuItemSlotRecipe,
            alert: alertSlotRecipe,
            autocomplete: autocompleteSlotRecipe,
            autocompleteItem: autocompleteItemSlotRecipe,
            avatar: avatarSlotRecipe,
            averageRating: averageRatingSlotRecipe,
            checkbox: checkboxSlotRecipe,
            dialog: dialogSlotRecipe,
            drawer: drawerSlotRecipe,
            field: fieldSlotRecipe,
            expandableMenuItem: expandableMenuItemSlotRecipe,
            featuredCountryItem: featuredCountryItemSlotRecipe,
            featuredImageWrapper: featuredImageWrapperSlotRecipe,
            footer: footerSlotRecipe,
            guestsPicker: guestsPickerSlotRecipe,
            guestsPickerSelect: guestsPickerSlotRecipe,
            hero: heroSlotRecipe,
            icon: iconSlotRecipe,
            list: listSlotRecipe,
            mapAdvancedMarker: mapAdvancedMarkerSlotRecipe,
            mapPopover: mapPopoverSlotRecipe,
            menu: menuSlotRecipe,
            mobileNumberInput: mobileNumberInputSlotRecipe,
            nativeSelect: nativeSelectSlotRecipe,
            navigation: navigationSlotRecipe,
            newsletter: newsletterSlotRecipe,
            popover: popoverSlotRecipe,
            rangePicker: rangePickerSlotRecipe,
            rangePickerDrawer: rangePickerDrawerSlotRecipe,
            searchEngineDesktop: searchEngineDesktopSlotRecipe,
            searchEngineInstantReservationCheckbox:
                searchEngineInstantReservationCheckboxSlotRecipe,
            searchEngineMobile: searchEngineMobileSlotRecipe,
            searchEngineMobileDrawer: searchEngineMobileDrawerSlotRecipe,
            searchLocation: searchLocationSlotRecipe,
            seoLinks: seoLinksSlotRecipe,
            support: supportSlotRecipe,
            tag: tagSlotRecipe,
            toast: toastSlotRecipe,
        },
        keyframes: {
            fadeSlideUp: {
                '0%': { opacity: 0, transform: 'translateY(12px)' },
                '100%': { opacity: 1, transform: 'translateY(0)' },
            },
        },
    },
});
